import { LoadingButton } from "@mui/lab";
import { Alert, Box, Grid, TextField, Typography } from "@mui/material";
import { toFormData } from "axios";
import FileDropZone from "components/FileDropZone";
import server_api from "data/server_apis/server_api";
import { useFormik } from "formik";
import ProductVideoUploadStatus from "pages/products/ProductVideoUploadStatus";
import React, { useEffect, useState } from "react";
import * as yup from "yup";

const validation = yup.object({
  title: yup.string().required("Title required"),
  desc: yup.string(),
  video: yup.mixed().required(),
});

const AdVideoCreate = () => {
  const [files, setFiles] = useState([]);
  const [fileStatus, setFileStatus] = useState({
    progress: 0,
    status: "pending",
  });
  const [submitting, setSubMitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const formik = useFormik({
    initialValues: {
      title: "",
      desc: "",
      video: null,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      console.log(data);
      uploadVideo(data);
    },
    validateOnChange: false,
  });

  useEffect(() => {
    formik.setFieldValue("video", files[0] ?? null);
  }, [files]);

  useEffect(() => {
    if (errorMessage) {
      Object.keys(errorMessage).forEach((key) => {
        console.log(key, errorMessage[key][0]);
        formik.setFieldError(key, errorMessage[key][0]);
      });
    }
  }, [errorMessage]);

  const uploadVideo = (data) => {
    setSubMitting(true);
    files.forEach((file, index) => {
      (async () => {
        try {
          const resp = await server_api.postForm(
            "/ads/video",
            toFormData(data),
            {
              onUploadProgress: (progressEvent) => {
                const percentComplete = parseInt(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                setFileStatus({ ...fileStatus, progress: percentComplete });
              },
            }
          );
          setSuccess(true);
          setFileStatus({ ...fileStatus, status: "success" });
          setSubMitting(false);
        } catch (err) {
          setErrorMessage(
            err.response?.status === 400 ? err.response?.data : null
          );
          setFileStatus({ ...fileStatus, status: "failed" });
          setSubMitting(false);
        }
      })();
    });

    // dispatch(getProductThunk(product.id));
  };
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <TextField
              label="Name"
              variant="outlined"
              name="title"
              fullWidth
              value={formik.values.title}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.title)}
              helperText={formik.errors.title}
              autoComplete="new-password"
              required
            />
          </Grid>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <TextField
              label="Description"
              variant="outlined"
              name="desc"
              fullWidth
              value={formik.values.desc}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.desc)}
              helperText={formik.errors.desc}
              autoComplete="new-password"
            />
          </Grid>
        </Grid>
        {!submitting && (
          <Grid container>
            <Grid item lg={8} md={12} sm={12} xs={12}>
              <FileDropZone
                maxFiles={1}
                accept={{
                  "video/mp4": [".mp4"],
                  "video/avi": [".avi"],
                  "video/x-matroska": [".mkv"],
                }}
                mode="video"
                files={files}
                setFiles={setFiles}
                error={formik.errors.video}
              />
            </Grid>
          </Grid>
        )}

        {formik.values.video && submitting && (
          <ProductVideoUploadStatus
            file={formik.values.video}
            progress={fileStatus.progress}
            status={fileStatus.status}
          />
        )}

        {errorMessage && (
          <Alert sx={{ my: 1 }} severity="error">
            Error occurred
          </Alert>
        )}

        {success && (
          <Alert sx={{ my: 1 }} severity="success">
            Success
          </Alert>
        )}

        <LoadingButton
          loading={submitting}
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
        >
          Add video
        </LoadingButton>
      </form>
    </>
  );
};

export default AdVideoCreate;
